export const isValidYouTubeIframe = (iframeHtml: string): boolean => {
  if (!iframeHtml.trim()) return false;

  // Check for reasonable length to prevent DoS
  if (iframeHtml.length > 10000) return false;

  // Parse the HTML to check if it's a valid iframe
  const parser = new DOMParser();
  const doc = parser.parseFromString(iframeHtml, "text/html");

  // Check for parsing errors
  const errorNode = doc.querySelector("parsererror");
  if (errorNode) return false;

  // Get the iframe element
  const iframe = doc.querySelector("iframe");
  if (!iframe) return false;

  // Check for dangerous attributes that shouldn't be present
  const dangerousAttrs = ["onload", "onerror", "onmessage", "srcdoc"];
  for (const attr of dangerousAttrs) {
    if (iframe.hasAttribute(attr)) return false;
  }

  // Check that it has a src attribute with a YouTube embed URL
  const src = iframe.getAttribute("src");
  if (!src) return false;

  // Validate that the src is a YouTube embed URL with stricter pattern
  const youtubeEmbedPattern =
    /^https:\/\/(www\.)?youtube\.com\/embed\/[\w-]+(\?[\w=&%-]*)?$/;
  return youtubeEmbedPattern.test(src);
};
